<mat-dialog-content>
    <table class="table table-bordered table-sm">
        <caption>Détails</caption>
        <thead>
            <th> Date </th>
            <th> Numéro de Série </th>
            <th> Action</th>
            <th> Installation </th>
        </thead>
        <tr *ngFor="let month of toShow">
            <td>{{niceDate(month.DATE_DEBUT)}}</td>
            <td>{{month.NUMERO_SERIE}}</td>
            <td>{{month.NOM_ACTION}}</td>
            <td>{{month.NOM_INSTALLATION}}</td>
        </tr>
    </table>
    <app-export-button [data]="toShow"></app-export-button>
</mat-dialog-content>

